<div class="pendo-cust-badge" [ngStyle]="stylePendoBadge()">
    <!-- <div *ngIf="pendoOpened" class="pendo-cust-badge-close rotate-center"></div> -->
    <img class="fade-in" src="/assets/images/help.svg" />
</div>